import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";
import UAParser from "ua-parser-js";

import EntityPageLayout from "components/EntityPageLayout";
import { entityLayoutData } from "components/EntityPageLayout/entityLayoutData";
import EntityPageAnalysis from "components/EntityPageLayout/EntityPageAnalysis";
import {
  entityInsightsUrl,
  sortOptions,
} from "components/EntityPageLayout/EntityPageAnalysis/EntityPageInsightsList";
import { entityReportsUrl } from "components/EntityPageLayout/EntityPageAnalysis/EntityPageReportsList";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const EntityInsightsTabPage: NextPageWithLayout = () => {
  return <EntityPageAnalysis />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const slug = context.params?.slug as string;
  const tab = context.query.tab as string;
  const page = context.query.page && parseInt(context.query.page as string);

  const userAgent = context.req.headers["user-agent"] as string;
  const deviceType = new UAParser(userAgent).getDevice().type;
  const isMobile = deviceType === "mobile";
  const session = JSON.parse(
    decodeURIComponent(context.req.cookies["ember_simple_auth-session"] || "{}")
  );
  const authenticated = !!session.authenticated?.token;
  const insightsUrl = entityInsightsUrl(
    slug,
    page || 1,
    "",
    sortOptions[0].sortStr,
    isMobile,
    tab,
    authenticated && !page ? "12" : "5"
  );
  const reportsUrl = entityReportsUrl(slug, 1, "");
  const publicationsUrl = tab === "reports" ? reportsUrl : insightsUrl;

  try {
    const [{ entity, entityLayoutFallback }, publications] = await Promise.all([
      entityLayoutData(slug, context),
      isSsr(context)
        ? baseFetcher(publicationsUrl, context)
        : Promise.resolve(null),
    ]);

    if (!entity || entity.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        fallback: {
          ...entityLayoutFallback,
          [`$inf$${publicationsUrl}`]: [publications],
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps entity analysis Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

EntityInsightsTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <EntityPageLayout {...pageProps}>{page}</EntityPageLayout>
    </SWRConfig>
  );
};

export default EntityInsightsTabPage;
